/* ============================================================
   BarklyPaw - 1+1 cart logic (up to two deals per order,
   Ram 2026-07-01). The buy-box ATC adds exactly ONE SET = 2 mats
   of one SIZE (same colour -> qty 2 of one variant; two colours
   -> 1 of each), the second mat free via the automatic per-size
   1+1 discount. Up to TWO SETS may exist in the cart, so a
   customer can buy the 1+1 deal twice. No quantity editing in the
   cart (steppers hidden in bp-landing.css); the self-heal below
   collapses any drift back to two sets. The old per-order cost cap
   is no longer enforced in theme code.
   Per-size mat count must stay EVEN (a set is 2 mats).
   Also: countdown timers, sticky mobile CTA, scroll CTAs.
   ============================================================ */
(function () {
  'use strict';
  window.BarklyPaw = window.BarklyPaw || {};
  var BP = window.BarklyPaw;

  var BUNDLE_QTY = 2; /* a 1+1 set = 2 mats of one size */
  var MAX_BUNDLE_SETS = 2;
  var MAX_BUNDLE_MATS = BUNDLE_QTY * MAX_BUNDLE_SETS;

  function sizeFromText(t) {
    var m = String(t || '').match(/\b(XS|XL|S|M|L)\b/);
    return m ? m[1] : null;
  }
  /* NOTE: the automatic 1+1 discount SPLITS a set into two cart lines
     (paid + free), so cost must be computed per VARIANT TOTAL, never
     per line (verified live 2026-06-12). */
  function variantTotals(cart) {
    var byV = {};
    (cart && cart.items || []).forEach(function (it) {
      var k = String(it.variant_id);
      if (!byV[k]) byV[k] = { qty: 0, size: sizeFromText(it.variant_title || it.title || '') };
      byV[k].qty += (it.quantity || 0);
    });
    return byV;
  }
  function cartMatCount(cart) {
    var byV = variantTotals(cart);
    return Object.keys(byV).reduce(function (sum, k) {
      return sum + (byV[k].qty || 0);
    }, 0);
  }
  /* ---- money helper (ILS) ---- */
  BP.money = function (cents) {
    var n = (cents / 100);
    return '$' + n.toLocaleString('en-US', { minimumFractionDigits: 0, maximumFractionDigits: 2 });
  };

  /* a 1+1 SET = two mats of the SAME SIZE. Same color -> qty 2 of one variant;
     two colors -> 1 of each (the per-size automatic 1+1 discount frees one of
     the pair, regardless of color). Both mats are the same size, so the set
     cost and the discount are identical either way. */
  function bundleItems(v1, v2) {
    if (v2 && String(v2) !== String(v1)) {
      return [{ id: Number(v1), quantity: 1 }, { id: Number(v2), quantity: 1 }];
    }
    return [{ id: Number(v1), quantity: BUNDLE_QTY }];
  }
  BP.bundleItems = bundleItems;

  /* fallback only: cart permalink that resets the cart to one 1+1 SET */
  function bundleCartUrl(v1, v2) {
    if (v2 && String(v2) !== String(v1)) {
      return '/cart/' + encodeURIComponent(String(v1)) + ':1,' + encodeURIComponent(String(v2)) + ':1?storefront=true';
    }
    return '/cart/' + encodeURIComponent(String(v1)) + ':' + BUNDLE_QTY + '?storefront=true';
  }
  BP.bundleCartUrl = bundleCartUrl;

  /* ---- lightweight toast ---- */
  BP.flash = function (msg) {
    var t = document.createElement('div');
    t.textContent = msg;
    t.style.cssText = 'position:fixed;inset-inline:0;bottom:20px;margin:0 auto;max-width:340px;' +
      'background:#382e2e;color:#fff;padding:13px 18px;border-radius:12px;text-align:center;' +
      'font-weight:700;z-index:9999;box-shadow:0 10px 30px rgba(0,0,0,.3);font-family:Assistant,sans-serif';
    document.body.appendChild(t);
    setTimeout(function () { t.remove(); }, 3200);
  };

  /* ---- skeleton helper ----
     Build a "what you just added" card from local variant data and
     inject it into the drawer BEFORE the API confirms. The user sees
     the exact product/size/color/price they picked instead of a blank
     spinner. drawer.renderContents() will wipe the skeleton when the
     real cart HTML lands (it replaces innerHTML of the section). */
  function buildSkeletonHTML(variantId) {
    var variantsEl = document.querySelector('[data-bp-variants]');
    if (!variantsEl) return '';
    var variants;
    try { variants = JSON.parse(variantsEl.textContent || '[]'); } catch (e) { return ''; }
    var v = null;
    for (var i = 0; i < variants.length; i++) {
      if (String(variants[i].id) === String(variantId)) { v = variants[i]; break; }
    }
    if (!v) return '';
    /* image: prefer variant featured_image, else active hero slide, else any product image */
    var img = '';
    if (v.featured_image && v.featured_image.src) img = v.featured_image.src;
    if (!img) {
      var heroImg = document.querySelector('.bp-gal-slide.is-active img') ||
                    document.querySelector('.bp-gal-slide img');
      if (heroImg) img = heroImg.currentSrc || heroImg.src || '';
    }
    /* price for the cart = single mat (2nd is free via 1+1 discount) */
    var priceCents = Number(v.price) || 0;
    var priceTxt = BP.money(priceCents);
    var variantTitle = (v.title || '').replace(' / ', ' · ');
    var safeImg = String(img).replace(/"/g, '%22');
    var safeTitle = (variantTitle + '').replace(/[<>]/g, '');
    return '<div class="bp-cart-skeleton" aria-hidden="true">' +
      '<div class="bp-skel-card">' +
        '<div class="bp-skel-img">' + (safeImg ? '<img src="' + safeImg + '" alt="" loading="eager">' : '') + '</div>' +
        '<div class="bp-skel-meta">' +
          '<div class="bp-skel-title">BarklyPaw Cooling Mat</div>' +
          '<div class="bp-skel-variant">' + safeTitle + '</div>' +
          '<div class="bp-skel-bogo">2 mats · second one free</div>' +
        '</div>' +
        '<div class="bp-skel-price">' + priceTxt + '</div>' +
      '</div>' +
      '<div class="bp-skel-loading"><span class="bp-skel-dot"></span><span class="bp-skel-dot"></span><span class="bp-skel-dot"></span></div>' +
    '</div>';
  }

  /* ---- 1+1 bundle add-to-cart ----
     AJAX-adds exactly 2 mats of the chosen variant(s), then opens the
     cart drawer. The cart can hold up to two 1+1 sets. If the AJAX path
     fails (e.g. a storefront protection layer challenges the request)
     it falls back to the cart permalink for one selected set. */
  BP.addBundle = function (variantId, btn, variantId2) {
    if (!variantId) {
      BP.flash('Choose a color and size first');
      return;
    }
    if (btn) { btn.disabled = true; btn.classList.add('bp-loading'); }
    function reEnable() {
      if (btn) { btn.disabled = false; btn.classList.remove('bp-loading'); }
      if (drawer) {
        drawer.classList.remove('bp-cart-busy');
        drawer.classList.remove('bp-cart-skeleton-shown');
        var skel = drawer.querySelector('.bp-cart-skeleton');
        if (skel) skel.remove();
      }
    }

    var drawer = document.querySelector('cart-drawer');
    var sectionIds = drawer ? 'cart-drawer,cart-icon-bubble' : 'cart-icon-bubble';

    /* OPEN THE DRAWER IMMEDIATELY — perceived-perf win.
       User sees the drawer slide in within ~50ms with a loading overlay,
       instead of waiting 1+s for two network round-trips to finish first.
       Also inject a "skeleton card" showing exactly what they just added
       (image + variant + price from local data) so they have something
       concrete to look at while the server-side render runs. */
    if (drawer && typeof drawer.open === 'function') {
      drawer.classList.add('bp-cart-busy');
      var inner = drawer.querySelector('.drawer__inner');
      var skel = buildSkeletonHTML(variantId);
      if (inner && skel) {
        /* purge any leftover skeleton from a prior click before injecting */
        var prev = inner.querySelector('.bp-cart-skeleton');
        if (prev) prev.remove();
        inner.insertAdjacentHTML('afterbegin', skel);
        drawer.classList.add('bp-cart-skeleton-shown');
      }
      try { drawer.open(); } catch (e) {}
    }

    /* TWO DEALS PER CART (Ram, 2026-07-01): the customer may buy the 1+1 deal
       up to twice. Check the current cart first; if one set is already there,
       the next click stacks a second set instead of replacing the cart. */
    fetch('/cart.js', { headers: { 'Accept': 'application/json' }, credentials: 'same-origin' })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        if (cartMatCount(cart) + BUNDLE_QTY > MAX_BUNDLE_MATS) {
          reEnable();
          BP.flash('You can add up to two 1+1 sets per order');
          return null;
        }
        return fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
          credentials: 'same-origin',
          body: JSON.stringify({
            items: bundleItems(variantId, variantId2),
            sections: sectionIds,
            sections_url: window.location.pathname
          })
        });
      })
      .then(function (r) { return r && r.json ? r.json() : null; })
      .then(function (res) {
        if (!res) return;
        if (res && res.status && Number(res.status) >= 400) {
          throw new Error(res.description || 'add failed');
        }
        reEnable();
        if (drawer && typeof drawer.renderContents === 'function' && res.sections) {
          drawer.classList.remove('is-empty');
          drawer.renderContents(res);
        } else if (!drawer) {
          window.location.href = '/cart';
        }
      })
      .catch(function (err) {
        /* network / protection-layer failure: fall back to the reliable
           permalink, which also RESETS the cart to one set. */
        window.location.href = bundleCartUrl(variantId, variantId2);
      });
  };

  /* ---- secondary CTAs: smooth-scroll to the buy box ----
     Any link pointing at #bp-buy brings the visitor to the buy box so
     they pick size/color there. It must never jump to the cart. */
  /* secondary "#bp-buy" links scroll to the buy box natively: the id is on
     the hero .bp-wrap (a real laid-out element) with scroll-margin-top in
     CSS. No JS needed - the browser handles the scroll reliably. */

  /* ---- countdown timers (any [data-bp-countdown] element) ----
     HONEST shipping-cutoff timer (Ram, 2026-06-13, replacing the old per-visitor
     evergreen reset). The element carries data-bp-cutoff-hour="14" = the real
     daily dispatch cutoff. The clock counts down to today's cutoff; once it
     passes, it rolls to tomorrow's cutoff and flips the "ships today/tomorrow"
     label. No fake offer-deadline, nothing resets mid-session — the urgency is a
     genuine, verifiable shipping promise (defensible on Meta + consumer law).
     Cutoff is computed in Israel time so every visitor sees the same true clock,
     regardless of their device timezone. */
  function initCountdowns() {
    var els = document.querySelectorAll('[data-bp-countdown]');
    if (!els.length) return;

    var WDAY = { Sun: 0, Mon: 1, Tue: 2, Wed: 3, Thu: 4, Fri: 5, Sat: 6 };
    // "now" as wall-clock parts in Asia/Jerusalem, independent of device TZ.
    function israelNow() {
      try {
        var p = new Intl.DateTimeFormat('en-US', {
          timeZone: 'Asia/Jerusalem', hour12: false, weekday: 'short',
          year: 'numeric', month: '2-digit', day: '2-digit',
          hour: '2-digit', minute: '2-digit', second: '2-digit'
        }).formatToParts(new Date()).reduce(function (a, x) { a[x.type] = x.value; return a; }, {});
        var hh = +p.hour === 24 ? 0 : +p.hour;
        return { secs: hh * 3600 + (+p.minute) * 60 + (+p.second), wd: WDAY[p.weekday], day: p.year + p.month + p.day };
      } catch (e) {
        var d = new Date();
        return { secs: d.getHours() * 3600 + d.getMinutes() * 60 + d.getSeconds(), wd: d.getDay(), day: 'x' };
      }
    }
    function pad(n) { return (n < 10 ? '0' : '') + n; }
    function paint(el, total) { // total = seconds remaining
      var dd = Math.floor(total / 86400), hh = Math.floor((total % 86400) / 3600),
          mm = Math.floor((total % 3600) / 60), ss = total % 60;
      var D = el.querySelector('[data-d]'), H = el.querySelector('[data-h]'),
          M = el.querySelector('[data-m]'), S = el.querySelector('[data-s]');
      if (D) D.textContent = pad(dd);
      var dwraps = el.querySelectorAll('[data-d-wrap]');
      for (var i = 0; i < dwraps.length; i++) dwraps[i].toggleAttribute('hidden', dd <= 0);
      if (H) H.textContent = pad(hh);
      if (M) M.textContent = pad(mm);
      if (S) S.textContent = pad(ss);
    }

    function tick() {
      var t = israelNow();
      els.forEach(function (el) {
        var H = el.querySelector('[data-h]'), M = el.querySelector('[data-m]'), S = el.querySelector('[data-s]');
        var D = el.querySelector('[data-d]');

        // MODE E: evergreen per-browser urgency window (Ram, 2026-06-13).
        // data-bp-evergreen-sec     = countdown length in seconds (2916 = 48m36s).
        // data-bp-evergreen-hold-sec = how long it sits at 00:00 after expiring
        //   before a fresh window starts (default 3 days = 259200).
        // The deadline is persisted per browser in localStorage and is NOT reset on
        // refresh — a returning visitor keeps counting down from where they were.
        // Once it hits zero it HOLDS at 00:00 for the hold period, then starts a fresh
        // window. Renders HH:MM:SS (hours : minutes : seconds; only the days box is
        // hidden, so the hours box shows 00 for a sub-hour window). The 1+1 offer
        // itself is permanent — this is an urgency timer, Ram's explicit choice.
        var evgSec = parseInt(el.getAttribute('data-bp-evergreen-sec'), 10);
        if (!isNaN(evgSec) && evgSec > 0) {
          var holdSec = parseInt(el.getAttribute('data-bp-evergreen-hold-sec'), 10);
          if (isNaN(holdSec) || holdSec < 0) holdSec = 259200; // 3 days
          var ekey = 'bpEvg:' + (el.getAttribute('data-bp-evergreen-key') || evgSec);
          var enow = Date.now();
          var edl;
          try { edl = parseInt(localStorage.getItem(ekey), 10); } catch (e) { edl = NaN; }
          if (isNaN(edl) || enow >= edl + holdSec * 1000) {
            // first visit, or the 00:00 hold period has fully elapsed → fresh window
            edl = enow + evgSec * 1000;
            try { localStorage.setItem(ekey, String(edl)); } catch (e) {}
          }
          // else: still counting down (enow < edl), or inside the 00:00 hold
          // (edl <= enow < edl + hold) — keep the stored deadline untouched so a
          // refresh never restarts the clock.
          var ediff = Math.floor((edl - enow) / 1000);
          if (ediff < 0) ediff = 0; // hold period shows 00:00:00
          var ehh = Math.floor(ediff / 3600);        // hours (00 for a sub-hour window)
          var emm = Math.floor((ediff % 3600) / 60);  // minutes
          var ess = ediff % 60;                       // seconds
          var ehid = el.querySelectorAll('[data-d-wrap]'); // hide only days; hours box stays (00)
          for (var ei = 0; ei < ehid.length; ei++) ehid[ei].setAttribute('hidden', '');
          if (D) D.textContent = '00';
          if (H) H.textContent = pad(ehh);
          if (M) M.textContent = pad(emm);
          if (S) S.textContent = pad(ess);
          el.removeAttribute('hidden');
          return;
        }

        // MODE 0: weekly recurring deadline (Ram, 2026-06-13). data-bp-weekly-day
        // (0=Sun..5=Fri) + data-bp-weekly-hour. Counts to the next occurrence in
        // Israel time and auto-restarts each week. The 1+1 offer itself is
        // permanent — this is a weekly urgency timer, by Ram's explicit choice.
        var wDay = parseInt(el.getAttribute('data-bp-weekly-day'), 10);
        var wHour = parseInt(el.getAttribute('data-bp-weekly-hour'), 10);
        if (!isNaN(wDay) && !isNaN(wHour)) {
          var daysUntil = (wDay - t.wd + 7) % 7;
          var total = daysUntil * 86400 + wHour * 3600 - t.secs;
          if (total <= 0) total += 7 * 86400;
          el.removeAttribute('hidden');
          paint(el, total);
          return;
        }

        // MODE 1: real offer-expiry deadline. data-bp-deadline = epoch ms
        // of the actual Shopify discount endsAt. Honest because the offer truly
        // expires then; when it passes, hide the urgency (no fake reset).
        var deadline = parseInt(el.getAttribute('data-bp-deadline'), 10);
        if (!isNaN(deadline) && deadline > 0) {
          var diff = Math.floor((deadline - Date.now()) / 1000);
          if (diff <= 0) { el.setAttribute('hidden', ''); return; }
          el.removeAttribute('hidden');
          var dd = Math.floor(diff / 86400);
          var hh = Math.floor((diff % 86400) / 3600);
          var mm = Math.floor((diff % 3600) / 60);
          var ss = diff % 60;
          if (D) D.textContent = pad(dd);
          var dwraps = el.querySelectorAll('[data-d-wrap]');
          for (var i = 0; i < dwraps.length; i++) dwraps[i].toggleAttribute('hidden', dd <= 0);
          if (H) H.textContent = pad(hh);
          if (M) M.textContent = pad(mm);
          if (S) S.textContent = pad(ss);
          return;
        }

        // MODE 2: daily shipping cutoff (data-bp-cutoff-hour)
        var cutoffH = parseInt(el.getAttribute('data-bp-cutoff-hour'), 10);
        if (isNaN(cutoffH)) cutoffH = 14;
        var cutoffSecs = cutoffH * 3600;
        var beforeCutoff = t.secs < cutoffSecs;
        var remain = beforeCutoff ? (cutoffSecs - t.secs) : (86400 - t.secs + cutoffSecs);
        var h = Math.floor(remain / 3600);
        var m = Math.floor((remain % 3600) / 60);
        var s = remain % 60;
        if (H) H.textContent = pad(h);
        if (M) M.textContent = pad(m);
        if (S) S.textContent = pad(s);
        var when = el.querySelector('[data-bp-cd-when]');
        if (when) when.textContent = beforeCutoff ? 'today' : 'tomorrow';
      });
    }
    tick();
    setInterval(tick, 1000);
  }

  /* ---- sticky mobile CTA: shows once the main hero ATC scrolls away ---- */
  function initSticky() {
    var bar = document.querySelector('[data-bp-sticky]');
    var heroBtn = document.querySelector('[data-bp-hero-atc]');
    if (!bar || !heroBtn) return;
    document.body.classList.add('bp-has-sticky');
    function onScroll() {
      var r = heroBtn.getBoundingClientRect();
      var gone = r.bottom < 0 || r.top > window.innerHeight;
      bar.classList.toggle('is-on', gone);
    }
    window.addEventListener('scroll', onScroll, { passive: true });
    onScroll();
  }

  /* ---- cart removal drops the WHOLE PAIR (all lines of that variant) ----
     Bundles are atomic: the discount splits a pair into a paid line + a
     free line, so removing only one LINE would leave a single full-price
     mat behind (Ram, 2026-06-12: "you can only buy the bundle"). Remove
     therefore zeroes the VARIANT's total quantity — both split lines die
     together; other bundles in the cart stay untouched. */
  function initCartRemoveLock() {
    document.addEventListener('click', function (e) {
      var btn = e.target.closest('cart-remove-button, .cart-remove-button');
      if (!btn) return;
      e.preventDefault();
      e.stopImmediatePropagation();
      var idxEl = btn.closest('[data-index]');
      var idx = parseInt((btn.dataset && btn.dataset.index) || (idxEl && idxEl.dataset.index), 10);
      var done = function () { window.location.reload(); };
      fetch('/cart.js', { headers: { 'Accept': 'application/json' }, credentials: 'same-origin' })
        .then(function (r) { return r.json(); })
        .then(function (cart) {
          var item = (cart.items || [])[idx - 1];
          if (!item) { /* no line index — safe fallback: clear all */
            return fetch('/cart/clear.js', { method: 'POST', headers: { 'Content-Type': 'application/json' } }).then(done);
          }
          /* Bundles are atomic 1+1 PAIRS by SIZE — removing a mat must drop its
             whole pair, never leave a single full-price mat. Rebuild by per-variant
             total, zero the clicked variant, then restore per-size parity (drop one
             more mat of that size if it is now odd). clear+re-add because update.js
             mishandles the discount-split lines (verified 2026-06-12). */
          var byV = variantTotals(cart);
          var order = [];
          (cart.items || []).forEach(function (it) {
            var k = String(it.variant_id); if (order.indexOf(k) < 0) order.push(k);
          });
          var ck = String(item.variant_id);
          if (byV[ck]) byV[ck].qty = 0;
          var bySize = {};
          order.forEach(function (k) { var s = byV[k].size || 'XL'; bySize[s] = (bySize[s] || 0) + byV[k].qty; });
          Object.keys(bySize).forEach(function (s) {
            if (bySize[s] % BUNDLE_QTY !== 0) {
              for (var i = 0; i < order.length; i++) {
                var k = order[i];
                if (byV[k].qty > 0 && (byV[k].size || 'XL') === s) { byV[k].qty -= 1; break; }
              }
            }
          });
          var readd = [];
          order.forEach(function (k) { if (byV[k].qty > 0) readd.push({ id: Number(k), quantity: byV[k].qty }); });
          return fetch('/cart/clear.js', { method: 'POST', headers: { 'Content-Type': 'application/json' }, credentials: 'same-origin' })
            .then(function () {
              if (!readd.length) return;
              return fetch('/cart/add.js', {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                credentials: 'same-origin',
                body: JSON.stringify({ items: readd })
              });
            })
            .then(done);
        })
        .catch(done);
    }, true); // capture phase: run before Dawn's own remove handler
  }

  /* ---- order-rules safety net ----
     Self-heals carts that drift out of bounds (permalink edits, console,
     third-party apps). Two rules:
       1. per-SIZE mat count is EVEN (a 1+1 set is 2 mats of one size) — an
          odd mat is trimmed ("you can only buy the bundle");
       2. TWO SETS PER ORDER — the cart may hold at most two sets (4 mats).
          Extra mats are trimmed while preserving full 1+1 pairs where possible.
     Runs deferred on page load. */
  function enforceBundleCeiling() {
    fetch('/cart.js', { headers: { 'Accept': 'application/json' }, credentials: 'same-origin' })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        if (!cart || !cart.items || cart.items.length === 0) return;
        /* per-VARIANT totals (the 1+1 discount splits sets into two lines) */
        var byV = variantTotals(cart);
        var order = []; // variant ids, most-recent first (cart.js order)
        (cart.items || []).forEach(function (it) {
          var k = String(it.variant_id);
          if (order.indexOf(k) < 0) order.push(k);
        });
        var updates = {}; // variant_id -> corrected TOTAL quantity
        var changed = false;
        function setQty(k, q) { byV[k].qty = q; updates[k] = q; changed = true; }
        function trimNewestMatOfSize(sz) {
          for (var i = 0; i < order.length; i++) {
            var k = order[i];
            if (byV[k].qty > 0 && (byV[k].size || 'XL') === sz) { setQty(k, byV[k].qty - 1); return true; }
          }
          return false;
        }
        function trimNewestSet() {
          var sz = null;
          for (var i = 0; i < order.length; i++) {
            if (byV[order[i]].qty > 0) { sz = byV[order[i]].size || 'XL'; break; }
          }
          if (sz == null) return false;
          var removed = 0;
          var guard = 0;
          while (removed < BUNDLE_QTY && guard < 200) {
            guard++;
            if (!trimNewestMatOfSize(sz)) break;
            removed++;
          }
          return removed > 0;
        }
        // rule 1: per-SIZE mat count must be EVEN. A 1+1 SET is two mats of the
        // SAME SIZE (colors may differ); the per-size automatic discount frees one
        // of each same-size pair. An odd count for a size = one unpaired full-price
        // mat, which we trim ("you can only buy the bundle"). Replaces the old
        // per-VARIANT-even rule, which wrongly deleted a legit two-COLOR pair
        // (each color qty 1).
        function fixParity() {
          var bySize = {};
          order.forEach(function (k) { var s = byV[k].size || 'XL'; bySize[s] = (bySize[s] || 0) + byV[k].qty; });
          Object.keys(bySize).forEach(function (s) { if (bySize[s] % BUNDLE_QTY !== 0) trimNewestMatOfSize(s); });
        }
        fixParity();
        // rule 2: TWO SETS PER ORDER. Mixed sizes are allowed as long as every
        // size remains paired and the cart total stays at four mats or below.
        var totalMats = function () {
          var t = 0; order.forEach(function (k) { t += byV[k].qty; }); return t;
        };
        var guard = 0;
        while (totalMats() > MAX_BUNDLE_MATS && guard < 200) { guard++; if (!trimNewestSet()) break; }
        fixParity();
        if (!changed) return;
        /* rebuild the cart cleanly (update.js mishandles discount-split
           lines): clear, then re-add each variant at its corrected total. */
        var readd = [];
        order.forEach(function (k) {
          if (byV[k].qty > 0) readd.push({ id: Number(k), quantity: byV[k].qty });
        });
        fetch('/cart/clear.js', { method: 'POST', headers: { 'Content-Type': 'application/json' }, credentials: 'same-origin' })
          .then(function () {
            if (!readd.length) return;
            return fetch('/cart/add.js', {
              method: 'POST',
              headers: { 'Content-Type': 'application/json' },
              credentials: 'same-origin',
              body: JSON.stringify({ items: readd })
            });
          })
          .then(function () {
            if (window.location.pathname === '/cart') window.location.reload();
          });
      })
      .catch(function () {}); // silent — if cart.js fails, no enforcement
  }
  BP.enforceBundleCeiling = enforceBundleCeiling;

  function boot() {
    initCountdowns();
    initSticky();
    initCartRemoveLock();
    /* Cart-ceiling self-heal runs OFF the critical path. It's a defensive
       safety net for edge-cases (permalink exploit, third-party app drift),
       not a primary code path, so we shouldn't pay its network round-trip
       on first paint. requestIdleCallback runs it when the browser is idle;
       fallback to a 1.5s setTimeout for browsers without rIC. */
    var deferredCeiling = function () { enforceBundleCeiling(); };
    if (typeof window.requestIdleCallback === 'function') {
      window.requestIdleCallback(deferredCeiling, { timeout: 3000 });
    } else {
      setTimeout(deferredCeiling, 1500);
    }
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else { boot(); }
})();
